// eslint-disable-next-line import/no-extraneous-dependencies
import { Iata } from '@reward-platform/platform-config'
import { request } from './singleflight'
import { getPartnerAccessToken, requestAccessToken, setPartnerAccessToken } from './utils'

export async function getAccessToken(partner: Iata): Promise<string | undefined> {
  const accessTokenInfo = getPartnerAccessToken(partner)
  const shouldRequestNewToken =
    !accessTokenInfo?.token || !accessTokenInfo?.expires || new Date() > accessTokenInfo.expires

  if (shouldRequestNewToken) {
    return request(`m2m-token:${partner}`, async () => {
      const { accessToken, expiresAt } = await requestAccessToken(partner)
      setPartnerAccessToken(partner, {
        expires: expiresAt,
        token: accessToken,
      })
      return accessToken
    })
  }
  return accessTokenInfo?.token
}
